import axios from 'axios'
import {
  IBulkEmailOptions,
  Template,
  FetchTemplate,
  IEmailScheduleOptions,
} from '../types'
import {
  fetchTriggerLinks as getTriggerLinks,
  getContactSearchService,
  getCustomFields,
  getCustomValues,
  getFetchSmartLists,
  getFetchTags,
  getHTMLPreview,
  getMessagePreview,
  getSwitchVersion,
  getUpdateTemplate,
  getVersionHistory as getVersionHistoryFunc,
  getEmailSettings,
  updateEmailSettings,
} from 'common/service'

import config from '../config'
import appConfig from '../config'
import { useStore } from '../store'
import { getEmailServiceHeader } from 'common/utils/helper'

declare global {
  interface Window {
    getToken: any
  }
}

axios.defaults.baseURL = appConfig.baseServiceUrl

const useService = () => {
  const store = useStore()

  axios.interceptors.request.use(async config => {
    config.headers['token-id'] = await window.getToken()
    if (
      config.url &&
      appConfig.marketPlaceURL &&
      config.url.includes(appConfig.marketPlaceURL)
    )
      config.headers = { ...config.headers, ...getEmailServiceHeader() }
    return config
  })
  const getHtmlPreview = getHTMLPreview(config)
  const getVersionHistory = getVersionHistoryFunc(config)
  const switchVersion = getSwitchVersion(config)
  const updateTemplate = getUpdateTemplate(config)

  function fetchTemplate(params: FetchTemplate) {
    let requestURL = `${config.marketPlaceURL}/emails/builder/meta/${params.locationId}/${params.id}`
    return axios.get(requestURL)
  }
  const contactSearch = getContactSearchService(config)
  const messagePreview = getMessagePreview(config)
  const fetchTags = getFetchTags(config)
  function bulkEmail(params: IBulkEmailOptions) {
    return axios.post(`${config.bulkRequestUrl}`, params)
  }
  const fetchSmartLists = getFetchSmartLists(config)

  const fetchCustomValues = (locationId: string) => {
    return axios.get(config.marketPlaceURL + '/custom-data/emails', {
      params: {
        locationId,
        types: 'custom-values',
      },
      headers: {
        'internal-channel': 'email-builder',
        'location-id': locationId,
      },
    })
  }

  const fetchCustomFields = getCustomFields(config)

  const fetchTriggerLinks = getTriggerLinks(config)

  const getSettings = getEmailSettings(config)
  const updateSettings = updateEmailSettings(config)

  function emailSchedule(params: IEmailScheduleOptions) {
    return axios.post(`${config.marketPlaceURL}/emails/schedule`, params)
  }

  function getEmailSchedule(id: string) {
    return axios.get(`${config.marketPlaceURL}/emails/schedule/${id}`)
  }
  return {
    getHtmlPreview,
    getVersionHistory,
    switchVersion,
    updateTemplate,
    fetchTemplate,
    contactSearch,
    fetchTags,
    messagePreview,
    bulkEmail,
    fetchSmartLists,
    fetchCustomValues,
    fetchCustomFields,
    emailSchedule,
    getEmailSchedule,
    fetchTriggerLinks,
    getSettings,
    updateSettings,
  }
}

export { useService }
